<template>
  <section>
    <div class="row">
      <div class="col">
        <div id="addressMap" style="height: 150px;" class="w-100"></div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col">
        <input
          type="text"
          class="form-control"
          placeholder="Ingresa tu colonia o código postal"
          id="directionAddress"
          ref="inputAddress"
          @keyup="verifyGoogleOptionSelected"
        >
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import { getStateZoneInfo } from '../../../check_prices/api/index.js';
import { initAutocompleteGmaps } from '../../../../common/utils/gmapsFunctions';
import segmentTrack from '../../../../common/mixins/segmentTrack'

export default {
  mixins: [segmentTrack],

  computed: {
    ...mapState({
      desiredLocation: state => state.warehouseRental.desiredLocation,
      googleOptionSelected: state => state.addressConfig.googleOptionSelected,
      stateZoneId: state => state.addressConfig.stateZoneId,
      latitude: state => state.countryInformation.latitude,
      longitude: state => state.countryInformation.longitude,
    })
  },

  methods: {
    ...mapMutations(['setWarehouseRental', 'setAddressConfig', 'setClient']),

    verifyGoogleOptionSelected() {
      this.setAddressConfig({
        googleOptionSelected: this.$refs.inputAddress.value === this.desiredLocation
      });
    },

    async addressSelected() {
      this.setWarehouseRental({
        desiredLocation: this.$refs.inputAddress.value
      });

      let stateZoneId = null;

      try {
        const response = await getStateZoneInfo(this.$refs.inputAddress.value);

        stateZoneId = response.data.state_zone_id;
        this.setClient({ cellphoneCountryCodeName: response.data.iso });
      } catch (error) {
        console.log(error);
      }

      this.setAddressConfig({ stateZoneId: stateZoneId });

      this.setWarehouseRental({ stateZoneId: stateZoneId });

      this.verifyGoogleOptionSelected();
    },

    mountAutocomplete() {
      const autocompleteAddress = initAutocompleteGmaps(
        'directionAddress', {
          mapId: 'addressMap',
          mapPosition: { lat: this.latitude, lng: this.longitude },
          mapZoom: 4
      });

      autocompleteAddress.addListener('place_changed', () => {
        const place = autocompleteAddress.getPlace();

        if (!place.geometry) return;

        this.$refs.inputAddress.value = place.formatted_address;
        this.addressSelected();
      });

      this.$refs.inputAddress.addEventListener('selected-map-direction', this.addressSelected);

      this.$refs.inputAddress.value = this.desiredLocation;
    }
  },

  mounted () {
    setTimeout(this.mountAutocomplete, 150);
    this.sendSegmentTrack('MEXICAN_WAREHOUSE_BOT_SEGMENT_PUBLIC', 'Mexican Warehouse Rental Bot', 'Address Step')
  }
}
</script>
